import { render, staticRenderFns } from "./LinkCenter.vue?vue&type=template&id=26d68ec4&scoped=true&"
import script from "./LinkCenter.vue?vue&type=script&lang=ts&"
export * from "./LinkCenter.vue?vue&type=script&lang=ts&"
import style0 from "./LinkCenter.vue?vue&type=style&index=0&id=26d68ec4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d68ec4",
  null
  
)

export default component.exports